import { render, staticRenderFns } from "./h5-login.vue?vue&type=template&id=beb120ce&scoped=true&"
import script from "./h5-login.vue?vue&type=script&lang=js&"
export * from "./h5-login.vue?vue&type=script&lang=js&"
import style0 from "./h5-login.vue?vue&type=style&index=0&id=beb120ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb120ce",
  null
  
)

export default component.exports